import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function queryInvoiceNo(data) {
  return request({
    url: URL.act.invoiceNo.queryInvoiceNo,
    method: 'post',
    data
  })
}

// 查询发票记录
export function queryPurchaseInvoiceRecords(data) {
  return request({
    url: URL.act.invoiceNo.queryPurchaseInvoiceRecords,
    method: 'post',
    data
  })
}

// 保存购买登记
export function saveInvoiceRecords(data) {
  return request({
    url: URL.act.invoiceNo.saveInvoiceRecords,
    method: 'post',
    data
  })
}

// 删除购买登记
export function delPurchase(data) {
  return request({
    url: URL.act.invoiceNo.delPurchase,
    method: 'post',
    data
  })
}

// 查询发票号【发票管理】
export function queryInvoiceNoByInvoiceNoManage(data) {
  return request({
    url: URL.act.invoiceNo.queryInvoiceNoByInvoiceNoManage,
    method: 'post',
    data
  })
}

// 修改发票部分字段
export function updateInvoiceNoFields(data) {
  return request({
    url: URL.act.invoiceNo.updateInvoiceNoFields,
    method: 'post',
    data
  })
}

// 保存发票领用记录
export function saveRecipientsInvoiceRecords(data) {
  return request({
    url: URL.act.invoiceNo.saveRecipientsInvoiceRecords,
    method: 'post',
    data
  })
}

// 查询发票领用记录
export function queryRecipientsInvoiceRecords(data) {
  return request({
    url: URL.act.invoiceNo.queryRecipientsInvoiceRecords,
    method: 'post',
    data
  })
}

// 删除发票领用记录
export function delRecipienting(data) {
  return request({
    url: URL.act.invoiceNo.delRecipienting,
    method: 'post',
    data
  })
}

